import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import withCatalogs from 'src/features/catalogs/withCatalogs'
import RequestAccessForm from './index'
import { actions as registerActions } from 'src/features/register/RegisterSlice'
import validate from 'src/features/register/components/RegisterForm/validate'
import * as flags from 'src/features/asyncFlags/AsyncFlagsSelector'
import { audienceTypes } from 'src/services/FW5ML/parsers/UserParser'
import { actions as ContactActions } from 'src/features/contactUs/ContactUsSlice'

const mapStateToProps = state => {
  const user = state?.session?.user || {}

  return {
    initialValues: {
      first_name: user?.firstName || null,
      email: user?.email || null,
      last_name: user?.lastName || null,
      company: user?.company || null,
      country: user?.address?.country || null,
      job_title: user?.job_title || null,
      job_function: user?.job_function || null,
      phone_number: user?.phone_number || null,
      license: audienceTypes.FREE
    },
    error: flags.getError('userRegistration')(state),
    busy: flags.isBusy('userRegistration')(state)
  }
}

const mapDispatchToProps = dispatch => ({
  requestUserRegistration: data =>
    dispatch(registerActions.requestUserRegistration(data)),
  requestConsultantContact: data =>
    dispatch(
      ContactActions.requestConsultantContact({
        ...data
      })
    )
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'request_access',
    validate,
    touchOnBlur: false
  }),
  withCatalogs({
    jobFunctions: 'jobFunction',
    therapy: 'therapy',
    country: 'country',
    heardAbout: 'heardAboutOptions'
  })
)(RequestAccessForm)
